unit DashboardParamsBuilder;

interface

uses
  System.SysUtils,
  JS,
  DateUtils;

type
  TDashboardParamsInput = record
    StartDate: TDate;
    EndDate: TDate;
    BranchIdList: string;
    WeekStartDay: Integer;
  end;

  TDashboardParamsBuilder = class
  public
    class function Build(const AInput: TDashboardParamsInput): JS.TJSObject; static;
    class function SpansLeapYear(ADate: TDate): Integer; static;
    class function DayLikeForLike(ADate: TDate): string; static;
  end;

implementation

class function TDashboardParamsBuilder.SpansLeapYear(ADate: TDate): Integer;
var
  lEndDate: TDate;
  lStartDate: TDate;
  lNoOfDays: Integer;
begin
  lEndDate := ADate;
  lStartDate := DateUtils.IncYear(lEndDate, -1);
  lNoOfDays := DaysBetween(lStartDate, lEndDate);

  if lNoOfDays = 366 then
    Result := 1
  else
    Result := 0;
end;

class function TDashboardParamsBuilder.DayLikeForLike(ADate: TDate): string;
const
  DAY_LIKE_FOR_LIKE = '(((vt.DateTime >= ''%s'') and (vt.DateTime < ''%s'')) or ' +
    ' ((vt.DateTime >= ''%s'') and (vt.DateTime < ''%s''))) ';
var
  lThisYearStartDate: string;
  lThisYearEndDate: string;
  lLastYearStartDate: string;
  lLastYearEndDate: string;
begin
  lThisYearStartDate := FormatDateTime('dd.mm.yyyy', ADate);
  lThisYearEndDate := FormatDateTime('dd.mm.yyyy', ADate + 1);
  lLastYearStartDate := FormatDateTime('dd.mm.yyyy', ADate - 364);
  lLastYearEndDate := FormatDateTime('dd.mm.yyyy', ADate + 1 - 364);
  Result := Format(DAY_LIKE_FOR_LIKE,
    [lThisYearStartDate, lThisYearEndDate, lLastYearStartDate, lLastYearEndDate]);
end;

class function TDashboardParamsBuilder.Build(const AInput: TDashboardParamsInput): JS.TJSObject;
var
  lLeapYearModifier: Integer;
  lStartDate: string;
  lEndDate: string;
  lCurrentYear: string;
  lThisYearStart: string;
  lThisYearEnd: string;
  lLastYearStart: string;
  lLastYearEnd: string;
  lMonthStart: string;
  lMonthEnd: string;
  lLFLStartThisYearYTD: string;
  lLFLEndThisYearYTD: string;
  lLFLStartLastYearYTD: string;
  lLFLEndLastYearYTD: string;
  lWeekThisYearStart: TDate;
  lWeekThisYearEnd: TDate;
  lWeekLastYearStart: TDate;
  lWeekLastYearEnd: TDate;
  lDateThisYear: TDate;
begin
  lLeapYearModifier := SpansLeapYear(AInput.EndDate);

  lStartDate := FormatDateTime('dd.mm.yyyy', AInput.StartDate);
  lEndDate := FormatDateTime('dd.mm.yyyy', AInput.EndDate);

  lCurrentYear := IntToStr(DateUtils.YearOf(AInput.EndDate));
  lThisYearStart := '01.01.' + IntToStr(DateUtils.YearOf(AInput.EndDate));
  lThisYearEnd := '31.12.' + IntToStr(DateUtils.YearOf(AInput.EndDate));
  lLastYearStart := '01.01.' + IntToStr(DateUtils.YearOf(AInput.EndDate) - 1);
  lLastYearEnd := '31.12.' + IntToStr(DateUtils.YearOf(AInput.EndDate) - 1);
  lMonthStart := '01.01.' + IntToStr(DateUtils.YearOf(AInput.EndDate));
  lMonthEnd := '31.12.' + IntToStr(DateUtils.YearOf(AInput.EndDate));

  lLFLStartThisYearYTD := '01.01.' + IntToStr(DateUtils.YearOf(AInput.EndDate));
  lLFLEndThisYearYTD := FormatDateTime('dd.mm.yyyy', AInput.EndDate + 1);
  lLFLStartLastYearYTD := '01.01.' + IntToStr(DateUtils.YearOf(AInput.EndDate) - 1);
  lLFLEndLastYearYTD := FormatDateTime('dd.mm.yyyy',
    ((AInput.EndDate + 1) - (365 + lLeapYearModifier)));

  lWeekThisYearStart := AInput.StartDate;
  lWeekThisYearEnd := AInput.EndDate;
  lWeekLastYearStart := AInput.StartDate - (364 + lLeapYearModifier);
  lWeekLastYearEnd := AInput.EndDate - (364 + lLeapYearModifier);
  lDateThisYear := AInput.EndDate;

  Result := JS.TJSObject.new;
  Result.Properties['StartDate'] := lStartDate;
  Result.Properties['EndDate'] := lEndDate;
  Result.Properties['BranchId'] := AInput.BranchIdList;
  Result.Properties['Today'] := lEndDate;
  Result.Properties['CurrentYear'] := lCurrentYear;
  Result.Properties['DayLikeForLike'] := DayLikeForLike(AInput.EndDate);
  Result.Properties['YearStart'] := lThisYearStart;
  Result.Properties['YearEnd'] := lThisYearEnd;
  Result.Properties['MonthStart'] := lMonthStart;
  Result.Properties['MonthEnd'] := lMonthEnd;
  Result.Properties['LFL_Start_0'] := FormatDateTime('dd.mm.yyyy', lWeekThisYearStart);
  Result.Properties['LFL_End_0'] := FormatDateTime('dd.mm.yyyy', lWeekThisYearEnd + 1);
  Result.Properties['LFL_Start_1'] := FormatDateTime('dd.mm.yyyy', lWeekLastYearStart);
  Result.Properties['LFL_End_1'] := FormatDateTime('dd.mm.yyyy', lWeekLastYearEnd + 1);
  Result.Properties['LFL_ThisDay_Start'] := FormatDateTime('dd.mm.yyyy', lDateThisYear);
  Result.Properties['LFL_ThisDay_End'] := FormatDateTime('dd.mm.yyyy', lDateThisYear + 1);
  Result.Properties['LFL_PrevDay_Start'] := FormatDateTime('dd.mm.yyyy', lDateThisYear - 364);
  Result.Properties['LFL_PrevDay_End'] := FormatDateTime('dd.mm.yyyy', lDateThisYear + 1 - 364);
  Result.Properties['LFL_Day_Start_0'] := lThisYearStart;
  Result.Properties['LFL_Day_End_0'] := lThisYearEnd;
  Result.Properties['LFL_Day_Start_1'] := lLastYearStart;
  Result.Properties['LFL_Day_End_1'] := lLastYearEnd;
  Result.Properties['LFL_START_THIS_YEAR_YTD'] := lLFLStartThisYearYTD;
  Result.Properties['LFL_END_THIS_YEAR_YTD'] := lLFLEndThisYearYTD;
  Result.Properties['LFL_START_LAST_YEAR_YTD'] := lLFLStartLastYearYTD;
  Result.Properties['LFL_END_LAST_YEAR_YTD'] := lLFLEndLastYearYTD;
end;

end.
